// extracted by css-extract-rspack-plugin
export default {"cls1":"AutoCompleteResultRow-cls1_qRu","cls2":"AutoCompleteResultRow-cls2_3ww AutoCompleteResultRow-cls1_qRu"};